module.exports = {
  plural: function (singularWord, count, pluralSuffix = 's') {
    let isPlural = count > 1
    return singularWord + ((isPlural === true) ? pluralSuffix : '')
  }
}



// WEBPACK FOOTER //
// ./src/modules/Pluralize.js